import { Button } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Modal from '~/components/Modal';
import { useFullRoutes } from '~/hooks';
import { closeModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';
import { ListingFeatureType } from '~/types/featureListingTypes';

export default function FeatureNoCreditModal({
  feature,
}: {
  feature: ListingFeatureType | null;
}) {
  const { t } = useTranslation('app');
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { PACKAGES_URL } = useFullRoutes();

  return (
    <Modal
      modalKey="featureListingNoCreditModal"
      title={t('featureListingPageTitle')}
      Footer={
        <div className="flex w-full gap-x">
          <Button
            ariaLabel="charge-credit-feature-listing"
            size="medium"
            variant="primary"
            className="w-full"
            onClick={() => {
              dispatch(closeModal('featureListingNoCreditModal'));
              navigate(PACKAGES_URL.ROOT);
            }}
          >
            {t('chargeCredit')}
          </Button>
          <Button
            ariaLabel="cancel-feature-listing-no-credit"
            size="medium"
            variant="secondary"
            className="w-full"
            onClick={() => {
              dispatch(closeModal('featureListingNoCreditModal'));
            }}
          >
            {t('cancel')}
          </Button>
        </div>
      }
      bodyClassName="!pt-2x"
    >
      <p className="text-title-5 text-gray__dark_2">
        {t('featureNoCreditQuestion', { name: feature?.title })}
      </p>
    </Modal>
  );
}
